import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
/*** */
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig/AuthConfig'
import { screens } from './utils/constants/UIConstants'
/***** */
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
/***** */
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

import App from './App'
import store from './store/Store'

export const msalInstance = new PublicClientApplication(msalConfig)

// Normalize firefighter URL casing before React boots.
// /Firefighter or /FIREFIGHTER → /firefighter
if (
  window.location.pathname.toLowerCase() === screens.firefighter &&
  window.location.pathname !== screens.firefighter
) {
  window.location.replace(
    screens.firefighter + window.location.search + window.location.hash,
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
